import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import HideDetail from '@material-ui/icons/FormatIndentDecrease';
import Paper from '@material-ui/core/Paper';
import ShowDetail from '@material-ui/icons/FormatIndentIncrease';
import ReferralView from '../referrals/ReferralView';

const ReferralViewPanel = ({ referral, request, notes, courtCase }) => {
    const [visible, setVisible] = useState(true);

    return (
        <Paper style={{ marginBottom: '1rem', padding: '1rem' }}>
            {!visible && <Button onClick={() => setVisible(true)} startIcon={<ShowDetail />} variant="contained" color="primary" size="small">Show Referral Details</Button>
            }
            <div hidden={!visible} >
                <ReferralView referral={referral} request={request} notes={notes} courtCase={courtCase} />
            </div>
            {visible && <Button style={{ marginTop: '1rem' }} onClick={() => setVisible(false)} startIcon={<HideDetail />} variant="contained" color="primary" size="small" >Hide Referral Details</Button>}
        </Paper>
    )
};

export default ReferralViewPanel;